import { useEffect, useContext, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { Box, Stack, Grid } from '@mui/material';
import AppToolBar from './appToolBar';
import Copyright from '../shared/components/copyright';
import PageRoute from './pageRoute';
import { HomeContext } from '../utils/contexts/homeContext';
import AlertComponent from '../shared/components/alert';
import ChangePassword from '../users/changePassword';
import { useCookies } from 'react-cookie'

function ViewPage(props) {

  const { isOpenChangePassword, handleCloseChangePassword } = props;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
      }}
    >
      <Stack>

        <PageRoute />
        <Outlet />

        <AlertComponent />

        {
          isOpenChangePassword &&
          <ChangePassword open={isOpenChangePassword} handleClose={handleCloseChangePassword} />
        }

      </Stack>
    </Box>
  );
}

export default function Dashboard() {

  const { homeState } = useContext(HomeContext);

  const navigate = useNavigate();
  const location = useLocation();
  const [cookies] = useCookies(['hplus_home_care_user_session_code']);

  const [isUserLogged, setIsUserLogged] = useState(false);
  const [isOpenChangePassword, setIsOpenChangePassword] = useState(false);

  useEffect(() => {
    console.log('location', location);
    console.log('homeState.loggedUser Dashboard', homeState.loggedUser);

    // if (location.pathname === "/user-login") {
    //   return;
    // }

    let tempIsUserLogged = false;

    if (homeState.loggedUser.isUserLogged) {
      const cookieCode = cookies.hplus_home_care_user_session_code;

      if (cookieCode && cookieCode.length > 0) {
        const textParts = atob(cookieCode).split('!;');
        console.log('parts', textParts);

        if (textParts.length >= 2) {
          const tempSessionCode = textParts[0].replaceAll('!', '').trim();
          const tempUserId = textParts[1].replaceAll('!', '').trim();

          if (tempSessionCode === homeState.loggedUser.sessionCode && tempUserId === homeState.loggedUser.userId.toString()) {
            tempIsUserLogged = true;
          }
        }
      }
    }
    setIsUserLogged(tempIsUserLogged);
    if (location.pathname !== "/user-login" && !tempIsUserLogged) {
      const tempCCD = cookies.hplus_home_care_ccd_param ?? homeState.ccd;
      console.log('Dashboard tempIsUserLogged false', tempCCD);
      navigate("/user-login?ccd=" + tempCCD, { replace: false });
    }
  }, [homeState.loggedUser, cookies]);


  const handleOpenChangePassword = () => {
    setIsOpenChangePassword(true);
  }

  const handleCloseChangePassword = () => {
    setIsOpenChangePassword(false);
  }

  return (
    <Box>
      <AppToolBar isUserLogged={isUserLogged} handleOpenChangePassword={handleOpenChangePassword} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          overflow: 'auto',
        }}
      >
        <Grid container spacing={0}>
          <Grid size={{ xs: 12, md: 12, lg: 12 }}>

            <ViewPage isOpenChangePassword={isOpenChangePassword} handleCloseChangePassword={handleCloseChangePassword} />

          </Grid>
          <Grid size={{ xs: 12, md: 12, lg: 12 }}>
            <Copyright sx={{ pt: 0 }} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}